<template>
  <div :class="['branches-list', {'branches-list_in-panel': inPanel}]">
    <div class="branches-list__search">
      <img src="/frontend/assets/img/icons/search2.svg" alt="">
      <input type="text" :placeholder="phrases.searchPlaceholder" v-model="searchString" @keypress="isLetter($event)">
    </div>
    <div class="branches-list__list">
      <wrapper v-for="(item, index) in branchesData"
               :key="item.name"
               :tag="getTag(item)"
               v-bind="compileAttrs(item)"
      >
        <span class="branches-list__letter">
          <template v-if="index === 0 || item.name.charAt(0) !== branchesData[index - 1].name.charAt(0)">
            {{ item.name.charAt(0) }}
          </template>
        </span>
        <span
        class="branches-list__city"
          v-metrik-click="(e) => sendStat(e, 'clickCityYM', item.name )"
        >
          <span>{{ item.name }}</span>
        </span>
        <span :class="['branches-list__info', {'branches-list__info_inactive': item.suspended }]">{{ item.info }}</span>
        <span v-if="item.selected" class="branches-list__check-mark">
          <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.33361 8.64338L12.9936 0.982544L14.1728 2.16088L5.33361 11L0.0302734 5.69671L1.20861 4.51838L5.33361 8.64338Z"
              fill="#292929"/>
          </svg>
        </span>
      </wrapper>
    </div>
    <template v-if="displayWeWorkBanner">
      <transition name="fade">
        <div class="veil" v-if="panelOpened" @click="panelOpened = false"></div>
      </transition>
      <transition name="slide">
        <div :class="['side-panel side-panel__alt', {'side-panel_opened': panelOpened}]" v-if="panelOpened">
          <div class="side-panel__inner">
            <span class="side-panel__close" @click="panelOpened = false"></span>
            <div>
              <h2 class="content-section__title content-section__title_small">Мы работаем над&nbsp;этой страницей</h2>
              <p class="links-description">Делаем ее&nbsp;более полезной и&nbsp;содержательной. Предлагаем посетить другие страницы сайта и&nbsp;узнать много интересного об&nbsp;истории денежного обращения.</p>
              <p class="links-description">Получить информацию о&nbsp;посещении филиала музея можно в&nbsp;разделе &laquo;<a href="/visit/">Как посетить</a>&raquo;</p>
              <links/>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import YMStat from "../tools/ymStat";
import Links from "./Links";
export default {
  name: 'BranchesList',
  components: {Links},
  props: {
    branchesData: {
      type: Array,
      default: () => [{
        name: '',
        link: '',
        info: '',
        notDisplayDetail: '',
        coords: '',
      }],
    },
    inPanel: {
      type: Boolean,
      default: false,
    },
    useSpans: {
      type: Boolean,
      default: true,
    },
    phrases: {
      type: Object,
      default() {
        return {
          searchPlaceholder: 'Поиск по филиалам',
        };
      },
    },
    displayWeWorkBanner: {
      type: Boolean,
      default: true,
    },
    locale: {
      type: String,
      default: 'ru'
    },
  },
  data() {
    return {
      searchString: '',
      panelOpened: false,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    //console.log(this.branchesData)
  },
  methods: {
    filter(name) {
      return this.searchString !== '' && !name.toUpperCase().includes(this.searchString.toUpperCase());
    },
    sendStat(e, param, value){
      YMStat[param](value)
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-zА-Яа-я\s]|-+$/.test(char)) return true;
      else e.preventDefault();
    },
    compileAttrs(item) {
      const attrs = {
        class: ['branches-list__item', {'g-hidden': this.filter(item.name)}],
      };

      if (this.getTag(item) === 'a') {
        attrs.href = item.link;
      } else {
        attrs.class.push('cursor-pointer');
      }

      if (item.notDisplayDetail && this.displayWeWorkBanner) {
        attrs.on = {
          click: (e) => {
            e.preventDefault();
            this.panelOpened = true
          },
        };
      }

      return attrs;
    },
    getTag(item) {
      return (
        (item.suspended && this.useSpans)
        || (item.notDisplayDetail && this.displayWeWorkBanner)
        || this.locale === 'en'
      ) ? 'span' : 'a';
    },
  },
}
</script>

<style scoped lang="scss">
.links-description {
  font-family: 'Golos';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.01em;
  color: #292929;
}

.links {
  display: flex;
  flex-direction: column;

  .link {
    display: flex;
    padding-top: 23px;
    padding-bottom: 23px;
    border-bottom: 1px solid #292929;
    text-decoration: none;

    :hover {
      text-decoration: underline;
    }

    >* {
      margin-top: auto;
      margin-bottom: auto;
    }

    .link-title {
      font-family: 'Golos';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
      letter-spacing: -0.01em;
      color: #292929;
      margin-left: 20px;
    }

    .link-arrow {
      margin-left: auto;
    }
  }
}

.cursor-pointer:hover {
  cursor: pointer;
  .branches-list__city {
    text-decoration: underline;
  }
}
</style>
